import React, { useEffect, useState } from 'react';
import { View, StyleSheet, Text, ImageBackground } from 'react-native';
import { COLORS, IMAGES } from '../constants';
import { Evaluation } from '../components'
import { useNavigation } from '@react-navigation/native';


export default function RatingScreen({ route }) {
  const navigation = useNavigation();
  const [category, setCategory] = useState(0);

  const setTableData = (param) => {
    console.log(param)

    switch (param) {
      case '2':
        setCategory(1);
        break;
      case '3':
        setCategory(2);
        break;
      case '4':
        setCategory(3);
        break;
      case '5':
        setCategory(5);
        break;
      default:
        setCategory(0);
    }
  }

  useEffect(() => {
    navigation.setOptions({ title: "Punktacja - kategoria " + route.params.category });
    setTableData(route.params.category);
  }, [])

  return (
    <ImageBackground
      source={IMAGES.bg2}
      style={styles.bg}
    >
      <View style={styles.container}>
        <Evaluation category={category} />
      </View>
    </ImageBackground>

  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: COLORS.background,
  },
  tbl: {
    color: COLORS.primary,
  },
  bg: {
    width: '100%',
    height: '100%'
  },
});